import '../../sass/layout/sections/section-banner.scss';

import Swiper from 'swiper';
import { Pagination, Autoplay,  EffectFade} from 'swiper/modules';
import Typewriter from 'typewriter-effect/dist/core';

const swiperBanner = document.getElementById('swiperBanner');
var typeText;

if(swiperBanner) {
    const pagination = swiperBanner.querySelector('.swiper-pagination');
    const swiper = new Swiper(swiperBanner, {
        modules: [Pagination, Autoplay, EffectFade],
        loop: false,
        speed: 1200,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: pagination,
        },
        autoplay: true,
        autoplay: {
            delay: 5000,
        },
        init: false,
    })  
    swiper.on('init', function () {
        const activeSlide = swiperBanner.querySelector('.swiper-slide-active');
        const text = activeSlide.querySelectorAll('h1 span');
        text.forEach((name, index) => {
            setTimeout(function(){
                name.style.opacity = 1;
                if(index === 2) {
                    name.classList.add('active');
                }
            },index * 1000)
        })


        // typeText = new Typewriter(text, {
        //     delay: 75
        // })

        // typeText.typeString(`${text.dataset.text}`).start()
    });
    swiper.on('slideChange', function () {
        const activeSlide = swiperBanner.querySelector('.swiper-slide-active');
        const text = activeSlide.querySelectorAll('h1 span');
        text.forEach((name, index) => {
            name.style.opacity = 0;
            name.classList.remove('active');
        })
        setTimeout(() => {
            const activeSlide = swiperBanner.querySelector('.swiper-slide-active');
            const text = activeSlide.querySelectorAll('h1 span');
            text.forEach((name, index) => {
                setTimeout(function(){
                    name.style.opacity = 1;
                    if(index === 2) {
                        name.classList.add('active');
                    }
                },index * 1000)
            })
        }, 500)

        // setTimeout(() => {
        //     const activeSlide = swiperBanner.querySelector('.swiper-slide-active');
        //     const text = activeSlide.querySelector('h1');
        //     typeText = new Typewriter(text, {
        //         delay: 75
        //     })
        //     typeText.typeString(`${text.dataset.text}`).start()
        // }, 500)

    });
    swiper.init();
}